import React from 'react';
import{ Toaster } from 'react-hot-toast';
import AutoForm from './Automotive/AutoForm';
const Form = () => {
    return (
        <div
            className="w-[525px] h-[785px] px-6 py-9 bg-secondary rounded-t-xl shadow-[inset_0px_-8px_25px_0px_rgba(0,0,0,0.25)] outline outline-1 outline-offset-[-1px] outline-white/0 backdrop-blur-lg inline-flex flex-col justify-between items-center">
        <Toaster/>
        <AutoForm/>
        </div>
    )
}
export default Form;


